<template>
    <div class="button-loader" :class="{ loading: isActive }">
      <div class="button-loader__content">
        <slot></slot>
      </div>
      <Transition name="fade">
        <div v-if="isActive" class="button-loader__spinner">
          <VIconMTS
            name="new-design/icon-loader"
            width="24"
            height="24"
          />
        </div>
      </Transition>
    </div>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'

export default {
  name: 'BaseButtonWithLoader',
  components: { VIconMTS },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.button-loader {
  position: relative;
  overflow: hidden;

  &.loading {
    .button-loader__content {
      opacity: 0;
    }
  }

  &__content {
    transition: opacity 0.1s ease-in;
  }

  &__spinner {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      animation: spinner-rotate 1.68s linear infinite;
    }
  }
}

.fade {
  @include fade-transition(0.1s, ease-in)
}

@keyframes spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
